import { SupplierWarehouseProps, SupplyOrderProps } from "@/types";

export const addressLine = (address: SupplierWarehouseProps): string => {
  const baseAddress = `${address?.street}, ${address?.number}`;
  const postalReference = `${address?.postalCode}, ${address?.neighborhood}`;
  const location = `${address?.city}, ${address?.state}`;

  if (address?.complement) {
    return `${baseAddress}, ${address?.complement}, ${postalReference} - ${location}`;
  } else {
    return `${baseAddress}, ${postalReference} - ${location}`;
  }
};

export const getDestinationAddress = (record?: SupplyOrderProps) => {
  let destinationAddress: string = "-";

  for (const item of record?.items || []) {
    if (item?.supplyChainLink) {
      for (const link of item.supplyChainLink) {
        const address = link?.saleOrder?.shipments?.[0]?.destinationAddress;
        if (address) {
          return address;
        }
      }
    }
  }

  const supplierWarehouseItem = record?.items?.find(
    (item) => item?.supplierWarehouse
  );
  if (supplierWarehouseItem?.supplierWarehouse) {
    destinationAddress = addressLine(
      supplierWarehouseItem.supplierWarehouse as SupplierWarehouseProps
    );
  }

  return destinationAddress;
};
